/**
 * Firestore collection names for persistent rooms.
 */
export const ROOMS_COLLECTION = 'persistentRooms';
export const LOGS_COLLECTION = 'roomLogs';
